<button mat-flat-button
  (click)="login()" 
  [disabled]="isLoggingIn"
  class="login-button">
  {{ isLoggingIn ? 'Signing In...' : 'Sign In With Microsoft' }}
</button>
